<vc-chart-wrapper
    class="vc-bar-chart-wrapper"
    [contentHeight]="contentHeight"
    [loading]="loading"
    [formContainer]="formContainer"
    [title]="title"
    [showHeader]="showHeader">
    <highcharts-chart
        class="no-title"
        [options]="options"
        style="width: 100%; display: block"
        [style.height]="height"
        (chartInstance)="onChartInstance($event)">
    </highcharts-chart>
</vc-chart-wrapper>
